import * as t from 'io-ts';
import { NonEmptyString } from 'io-ts-types';
import { OptionalAddressCodec } from '../address.types';

export const LocationCodec = t.partial({
    identifier: NonEmptyString,
    address: OptionalAddressCodec,
});

export type ApiLocation = t.TypeOf<typeof LocationCodec>;
